import React from "react";
import "./EventActivityVisual.scss";

const EventActivityVisual = ({ imageUrl }) => {
  // Handle require() which may return an object with .default property
  const resolvedImageUrl = imageUrl?.default || imageUrl;

  if (!resolvedImageUrl) {
    return null;
  }

  return (
    <div className="event-activity-visual event-activity-visual--image">
      <img src={resolvedImageUrl} alt="Activity" />
    </div>
  );
};

export default EventActivityVisual;
